// extracted by mini-css-extract-plugin
export default {"container":"HealthBar_container__pfXg4","gloss":"HealthBar_gloss__z1PJU","label":"HealthBar_label__WK3Oy","meter":"HealthBar_meter__Ix9yz"};